import Localizer from "@Scripts/Common/Localizer";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";

@Component({ name: "InfoRequestLink" })
export default class InfoRequestLink extends Vue {
    public localizer: any = Localizer;
    public showForm: boolean = false;

    @Prop() readonly recaptchaSiteKey: string;
    @Prop() readonly message: string;
    @Prop() readonly requestUrl: string;

    public setShowForm() {
        this.showForm = !this.showForm;
    }

    public setAnalytics() {
        GTagHelper.sendEvent("click", "info_request");
    }
};